/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/

function htmlEscape(text) {
    if (typeof text !== "string") {
        return text;
    }

    return text.replace(/&/g, '&amp;')
        .replace(/&/g, '&amp;')   // it's not neccessary to escape >
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;')
        .replace(/%3C/g, '')
        .replace(/%2F/g, '');
}

export default htmlEscape;
